
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import AddContentForm from "@/components/forms/AddContentForm";
import { CirclePlus } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface AddContentButtonProps {
  className?: string;
  variant?: "default" | "outline" | "secondary" | "icon";
  id?: string;
}

const AddContentButton = ({ 
  className, 
  variant = "default", 
  id
}: AddContentButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isMobile = useIsMobile();

  const handleOpenChange = (open: boolean) => {
    console.log("Dialog open change:", open);
    setIsDialogOpen(open);
  };

  const handleComplete = () => {
    console.log("Form complete, closing dialog");
    setIsDialogOpen(false);
  };

  const triggerButtonId = id || "add-content-trigger";

  // Consistent blue styling for both light and dark modes
  const buttonBaseClasses = "bg-[#0073FF] hover:bg-[#0060D6] text-white transition-colors";

  return (
    <Dialog open={isDialogOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        {variant === "icon" ? (
          <Button 
            className={`${buttonBaseClasses} h-10 w-10 p-0 rounded-xl flex items-center justify-center ${className}`}
            id={triggerButtonId}
          >
            <CirclePlus size={20} className="text-white" />
          </Button>
        ) : (
          <Button 
            className={`${buttonBaseClasses} flex items-center gap-2 px-4 py-2 rounded-xl ${className}`}
            id={triggerButtonId}
          >
            <span>Add Content</span>
            <CirclePlus size={20} className="text-white" />
          </Button>
        )}
      </DialogTrigger>

      {/* Always render dialog content - no conditional rendering */}
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Add New Content</DialogTitle>
          <DialogDescription>
            Add a URL to save content to your Clustr library
          </DialogDescription>
        </DialogHeader>
        <AddContentForm onComplete={handleComplete} />
      </DialogContent>
    </Dialog>
  );
};

export default AddContentButton;
